import {createFileRoute} from "@tanstack/react-router";

/** Nested path matcher only. The page stays mounted on the parent layout route. */
function ConfigPageSplatMatch() {
    return null;
}

/** Nested path under a config page, e.g. media library folder or asset. */
export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_configScaffold/$pageKey/$",
)({
    component: ConfigPageSplatMatch,
});
